import { render } from "./AddTollModal.vue?vue&type=template&id=205081b4&scoped=true"
import script from "./AddTollModal.vue?vue&type=script&lang=js"
export * from "./AddTollModal.vue?vue&type=script&lang=js"

import "./AddTollModal.vue?vue&type=style&index=0&id=205081b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205081b4"]])

export default __exports__